import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {NgClass} from '@angular/common';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TranslatePipe} from '@ngx-translate/core';
import {DropdownMenuComponent} from '../dropdown-menu/dropdown-menu.component';

@Component({
  selector: 'app-case-state-filter',
  imports: [
    NgClass,
    MatCheckboxModule,
    TranslatePipe,
    DropdownMenuComponent
  ],
  templateUrl: './case-state-filter.component.html',
  styleUrl: './case-state-filter.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CaseStateFilterComponent {

  readonly filterIconSrc = 'assets/icons/filter.svg';

  @Input()
  states: string[] = [];

  @Input()
  selectedStates: string[] = [];

  @Output()
  selectedStatesChange = new EventEmitter<string[]>();

  get totalNumberOfStates(): number {
    return this.states.length;
  }

  get visibleNumberOfStates(): number {
    return this.selectedStates.length;
  }

  get allSelected(): boolean {
    return this.states.length > 0 && this.selectedStates.length === this.states.length;
  }

  get someSelected(): boolean {
    return this.selectedStates.length > 0 && !this.allSelected;
  }

  isSelected(state: string): boolean {
    return this.selectedStates.includes(state);
  }

  toggleAll(checked: boolean) {
    const nextSelection = checked ? [...this.states] : [];
    this.selectedStatesChange.emit(nextSelection);
  }

  toggleState(state: string, checked: boolean) {
    const nextSelection = new Set(this.selectedStates);
    if (checked) {
      nextSelection.add(state);
    } else {
      nextSelection.delete(state);
    }
    const orderedSelection = this.states.filter(option => nextSelection.has(option));
    this.selectedStatesChange.emit(orderedSelection);
  }
}
